/**
 * @generated SignedSource<<78f9573f6c0b9058744484362785afc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivateFeaturesPLUMutation$variables = {
  password: string;
  username: string;
};
export type ActivateFeaturesPLUMutation$data = {
  readonly activatePLUFromInfoTab: {
    readonly pluCategories: ReadonlyArray<{
      readonly id: string;
    }>;
  } | null;
};
export type ActivateFeaturesPLUMutation = {
  response: ActivateFeaturesPLUMutation$data;
  variables: ActivateFeaturesPLUMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "password"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "username"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "password",
        "variableName": "password"
      },
      {
        "kind": "Variable",
        "name": "username",
        "variableName": "username"
      }
    ],
    "concreteType": "ActivatePLUPayload",
    "kind": "LinkedField",
    "name": "activatePLUFromInfoTab",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PLUCategory",
        "kind": "LinkedField",
        "name": "pluCategories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivateFeaturesPLUMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActivateFeaturesPLUMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "ead7f87d291822684b5bac25df327485",
    "id": null,
    "metadata": {},
    "name": "ActivateFeaturesPLUMutation",
    "operationKind": "mutation",
    "text": "mutation ActivateFeaturesPLUMutation(\n  $username: String!\n  $password: String!\n) {\n  activatePLUFromInfoTab(password: $password, username: $username) {\n    pluCategories {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "67fe9e388d29bc3c157d6128a7678984";

export default node;
